import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { DeviceTypeCodes } from '@/features/devices/schemas/devices.schemas.ts';

export type PlantDeviceFields = {
  deviceTypeCode: DeviceTypeCodes;
  fieldCode: number;
  time: string;
  value: number;
  unit: string;
  aggregation: string;
  last24Hours: PlantDeviceFields[];
};

export type GetPlantDevicesOverviewResponse = {
  storage: PlantDeviceFields[];
  production: PlantDeviceFields[];
  config: {
    storage: Partial<Record<DeviceTypeCodes, number[]>>;
    production: Partial<Record<DeviceTypeCodes, number[]>>;
  };
};

export const useGetPlantDevicesOverviewQuery = ({
  plantId,
  dateRange,
  enabled = true,
}: {
  plantId?: string;
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['plants', plantId, 'devices', 'overview'],
    queryFn: async () => {
      const { data } = await client.get<{ body: GetPlantDevicesOverviewResponse }>(
        `/plants/${plantId}/devices/overview`,
        {
          params: {
            startDate: `${new Date(dateRange.startDate).getTime()}`,
            endDate: `${new Date(dateRange.endDate).getTime()}`,
          },
        }
      );

      return data.body;
    },
    staleTime: 1000 * 60,
    enabled,
  });
};
